// export const LeftArrow = ({onClick}: {onClick?: () => any}) => {
//   return (
//     <svg
//       onClick={onClick}
//       width="8"
//       height="12"
//       viewBox="0 0 8 12"
//       fill="none"
//       xmlns="http://www.w3.org/2000/svg">
//       <path d="M1 1L6 6L1 11" stroke="#363636" strokeWidth="2" />
//     </svg>
//   );
// };

type LeftArrowProps = {
  onClick?: () => any;
  disabled?: boolean;
};

export const LeftArrow = ({onClick, disabled}: LeftArrowProps) => {
  const color = disabled ? '#7D7D7D' : '#000000';
  return (
    <svg
      onClick={onClick}
      width="8"
      height="12"
      viewBox="0 0 8 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M1 1L6 6L1 11" stroke={color} strokeWidth="2" />
    </svg>
  );
};
